import React from 'react';
import PropTypes from 'prop-types';

import Stock from '../../../components/Stock';
import GroupWrapper from '../../../components/GroupWrapper';

import is768 from '../../../common/utils/is768';

const Page = ({ pageData }) => {
  const { data } = pageData;
  const { title, bonds } = data;

  const { text, mobileOnly } = title;

  let groupWrapperTitle = text;

  if (mobileOnly && !is768()) {
    groupWrapperTitle = false;
  }

  return (
    <GroupWrapper title={groupWrapperTitle}>
      {bonds.map((item, i) => <Stock key={i} index={i} {...item} />)}
    </GroupWrapper>
  );
};
Page.propTypes = {
  pageData: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.shape({
        text: PropTypes.string,
        mobileOnly: PropTypes.bool,
      }),
      bonds: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default Page;
